import FormPageFake, {
  THEMES as FAKE_THEMES,
} from '@/components/fakes/formPagesFake';

function FormMiMovistarFake() {
  return (
    <FormPageFake
      formTemplateFakes={[
        {
          theme: FAKE_THEMES.boxRadioButtonList,
          fakeLength: 2,
        },
        {
          theme: FAKE_THEMES.textList,
          fakeLength: 2,
        },
        {
          theme: FAKE_THEMES.textList,
          fakeLength: 3,
        },
      ]}
    />
  );
}
export default FormMiMovistarFake;
